import React from 'react';

import { IMfaSessionDetails } from 'src/apps/mfa/services/MfaDashboardServiceTypes';
import { DashboardTableLabel } from 'src/common/components/DashboardTableLabel/DashboardTableLabel';
import { IReportInfo } from 'src/common/components/report-info/ReportInfo';
import { formatShortMonthDatetime } from 'src/common/helpers/DateFormatHelper';

import './MfaSingleSessionHeader.scss';

export const getMfaInfoItems = (): IReportInfo[] => {
	return [
		{
			key: 'lastModified',
			label: 'Last modified',
			textFormatter: formatShortMonthDatetime
		},
		{
			key: 'owner',
			label: 'Owner'
		},
		{
			key: 'labels',
			label: 'Session labels',
			customValueRenderer: (session: IMfaSessionDetails) => {
				const labels = session.labels || [];
				return <DashboardTableLabel labels={labels} />;
			}
		}
	];
};
